import ItemsV3Serializer from '@square/dashboard-items-data/serializers/items-v3-base';
export default class Resource extends ItemsV3Serializer {}